<section>
  <header>
    @if (icon) {
      <app-icon [src]="icon"></app-icon>
    }
    <h2>{{ label }}</h2>
    <span class="spacer"></span>
    <button
      app-icon-button
      src="assets/images/icons/close.svg"
      alt="{{ Translations.Close | translate }}"
      (click)="dismiss.emit()">
      {{ Translations.Close | translate }}
    </button>
  </header>
  <div class="content">
    <ng-content></ng-content>
  </div>
</section>
